import styled from "styled-components";

export const IncidentReasonFormStyle = styled.div`
    .ant-checkbox-group,
    .ant-radio-group {
        display: flex;
        flex-direction: column;
    }
`;
